import { Skeleton } from 'antd';

export const SummaryLoading = () => {
  return (
    <div className="min-h-screen p-9">
      <Skeleton active className="mb-9" />
      <Skeleton active className="mt-9 mb-9" />
      <Skeleton active className="mt-9 mb-9" />
    </div>
  );
};
